import styled from "@emotion/styled";
import { Text } from "@repo/skapa";

const LabelContainer = styled.div`
  // is this needed?
  // white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 0 0.125rem 0;
`;

interface LabelProps {
  htmlFor?: string;
  label?: string;
  bold?: boolean;
  noWrap?: boolean;
}

export const Label = ({ htmlFor, label, bold, noWrap }: LabelProps) => (
  <LabelContainer>
    <label htmlFor={htmlFor}>
      {bold ? (
        <Text textStyle="Heading.XS" noWrap={noWrap}>
          {label}
        </Text>
      ) : (
        <Text noWrap={noWrap}>{label}</Text>
      )}
    </label>
  </LabelContainer>
);
